import { r as registerInstance, h } from './index-5faac9d7.js';
import { $ as ECarouselRelation } from './currency-7be6806c.js';

const pesLifecycleServicesWrapperCss = ":host{display:block}";

const LifecycleServicesWrapper = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.sectionTitle = undefined;
    this.data = undefined;
    this.versionLabel = undefined;
    this.relationType = undefined;
    this.isBackgroundGrey = false;
    this.showMoreLabel = undefined;
    this.showLessLabel = undefined;
    this.selectLabel = undefined;
    this.sortByLabel = undefined;
    this.defaultRecordCount = 2;
    this.isAPCSite = false;
    this.apcCta = undefined;
    this.productAvailabilityInfo = undefined;
    this.commerceConnectorSettings = null;
    this.apcCtaUrl = undefined;
    this.host = '';
    this.agentChatCscId = undefined;
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.useNewUiForLifecycle = false;
  }
  render() {
    var _a, _b;
    if (this.useNewUiForLifecycle) {
      return (h("pes-products-filter", { sectionTitle: this.sectionTitle, data: this.data, showMoreLabel: this.showMoreLabel, showLessLabel: this.showLessLabel, selectLabel: this.selectLabel, sortByLabel: this.sortByLabel, defaultRecordCount: this.defaultRecordCount, isAPCSite: this.isAPCSite, apcCta: this.apcCta, productAvailabilityInfo: this.productAvailabilityInfo, commerceConnectorSettings: this.commerceConnectorSettings, apcCtaUrl: this.apcCtaUrl, host: this.host, agentChatCscId: this.agentChatCscId, relationType: (_a = this.relationType) !== null && _a !== void 0 ? _a : ECarouselRelation.crossSellLife, countryCode: this.countryCode, languageCode: this.languageCode }));
    }
    return (h("pes-products-carousel", { sectionTitle: this.sectionTitle, data: this.data, versionLabel: this.versionLabel, relationType: (_b = this.relationType) !== null && _b !== void 0 ? _b : ECarouselRelation.crossSellLife, isBackgroundGrey: this.isBackgroundGrey }));
  }
};
LifecycleServicesWrapper.style = pesLifecycleServicesWrapperCss;

export { LifecycleServicesWrapper as pes_lifecycle_services_wrapper };
